import React, { useState } from "react";

const HODAssignmentModal = ({
  isVisible,
  departmentInfo,
  facultyData,
  selectedHOD,
  onClose,
  onSubmit,
  onHODChange,
  error,
  success,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  if (!isVisible) return null;

  const title = departmentInfo.head ? "Update Head of Department" : "Assign Head of Department";
  const submitText = departmentInfo.head ? "Update" : "Assign";

  const filteredFaculty = facultyData
    .filter(faculty => 
      faculty.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      faculty.role.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (a.id === selectedHOD) return -1;
      if (b.id === selectedHOD) return 1;
      return a.name.localeCompare(b.name);
    });

  const selectedFaculty = facultyData.find(faculty => faculty.id === selectedHOD);

  return (
    <>
      <div className="modal-backdrop fade show" style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1040,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
      }}></div>

      <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              {error && <div className="alert alert-danger">{error}</div>}
              {success && <div className="alert alert-success">{success}</div>}

              <form onSubmit={onSubmit}>
                <div className="form-group">
                  <label className="form-label">
                    Select Faculty Member as HOD <span className="text-danger">*</span>
                  </label>
                  
                  <div className="dropdown">
                    <div 
                      className="form-control d-flex align-items-center justify-content-between"
                      style={{ 
                        cursor: "pointer",
                        padding: "0.375rem 0.75rem",
                        minHeight: "calc(1.5em + 0.75rem + 2px)"
                      }}
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      {selectedFaculty ? (
                        <span>{selectedFaculty.name} - {selectedFaculty.role}</span>
                      ) : (
                        <span className="text-muted">Select a faculty member</span>
                      )}
                      <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`}></i>
                    </div>
                    
                    {isOpen && (
                      <div 
                        className="dropdown-menu show w-100"
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          border: "1px solid #dee2e6",
                        }}
                      >
                        <div className="px-2 py-1 sticky-top bg-white">
                          <input
                            type="text"
                            className="form-control form-control-sm mb-2"
                            placeholder="Search faculty..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            autoFocus
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                        
                        {filteredFaculty.length > 0 ? (
                          filteredFaculty.map((faculty) => (
                            <button
                              key={faculty.id}
                              type="button"
                              className={`dropdown-item ${selectedHOD === faculty.id ? 'active' : ''}`}
                              onClick={() => {
                                onHODChange(faculty.id);
                                setIsOpen(false);
                                setSearchTerm("");
                              }}
                            >
                              {faculty.name} - {faculty.role}
                            </button>
                          ))
                        ) : (
                          <div className="dropdown-item text-muted">No matching faculty found</div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="submit-section text-end mt-3">
                  <button type="button" className="btn btn-secondary me-2" onClick={onClose}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {submitText}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HODAssignmentModal;